<template>
  <div class="container">
    <!--<el-button type="primary" @click="getRegionImage">刷新</el-button>-->
    <el-tag type="success"
      >总数 <el-badge class="mark" :value="imageList.length"/></el-tag>
    <el-button
      type="text"
      size="mini"
      @click="changeShow"
      v-if="allShow === false"
      >查看全部</el-button
    >
    <el-button type="text" size="mini" @click="changeShow" v-else>查看差异</el-button>
    <!--<el-button type="text" size="mini">查看差异</el-button>-->
    <el-row :gutter="10" class="box">
      <h3>漏框 <el-badge class="mark" :value="count[1] ? count[1].length : 0"/></h3>
      <reginImageCheckedItem
        @fixButtonClick="activeImage => fixButtonClick(activeImage, image)"
        class="region-img-item"
        v-for="(image, idx) in count[1] ? count[1] : []"
        :right-regions="image.right_regions"
        :error-regions="image.error_regions"
        :image="image.dish_img_url"
        :key="idx"
      ></reginImageCheckedItem>
    </el-row>
    <el-row :gutter="10" class="box">
      <h3>多框 <el-badge class="mark" :value="count[4] ? count[4].length : 0"/></h3>
      <reginImageCheckedItem
        @fixButtonClick="activeImage => fixButtonClick(activeImage, image)"
        class="region-img-item"
        v-for="(image, idx) in count[4] ? count[4] : []"
        :right-regions="image.right_regions"
        :error-regions="image.error_regions"
        :image="image.dish_img_url"
        :key="idx"
      ></reginImageCheckedItem>
    </el-row>
    <el-row :gutter="10" class="box">
      <h3>框不准 <el-badge class="mark" :value="count[3] ? count[3].length : 0"/></h3>
      <reginImageCheckedItem
        @fixButtonClick="activeImage => fixButtonClick(activeImage, image)"
        class="region-img-item"
        v-for="(image, idx) in count[3] ? count[3] : []"
        :right-regions="image.right_regions"
        :error-regions="image.error_regions"
        :image="image.dish_img_url"
        :key="idx"
      ></reginImageCheckedItem>
    </el-row>
    <el-row :gutter="10" class="box">
      <h3>误框 <el-badge class="mark" :value="count[2] ? count[2].length : 0"/></h3>
      <reginImageCheckedItem
        @fixButtonClick="activeImage => fixButtonClick(activeImage, image)"
        class="region-img-item"
        v-for="(image, idx) in count[2] ? count[2] : []"
        :right-regions="image.right_regions"
        :error-regions="image.error_regions"
        :image="image.dish_img_url"
        :key="idx"
      ></reginImageCheckedItem>
    </el-row>
    <el-row :gutter="10" class="box">
      <h3>正确 <el-badge class="mark" :value="count[0] ? count[0].length : 0"/></h3>
      <reginImageCheckedItem
        @fixButtonClick="activeImage => fixButtonClick(activeImage, image)"
        class="region-img-item"
        v-for="(image, idx) in count[0] ? count[0] : []"
        :right-regions="image.right_regions"
        :error-regions="image.error_regions"
        :image="image.dish_img_url"
        :key="idx"
      ></reginImageCheckedItem>
    </el-row>
    <el-dialog v-if="fixDialog" :visible.sync="fixDialog" width="50%">
      <reginImageCheckedDialogItem
        class="region-img-item"
        :right-regions="activeImage.right_regions"
        :error-regions="activeImage.error_regions"
        :image="activeImage.dish_img_url"
        :key="idx"
      >
      </reginImageCheckedDialogItem>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiFixRegions} from '@/api';
import reginImageCheckedItem from './reginImageCheckedItem';
import reginImageCheckedDialogItem from './reginImageCheckedDialogItem';

export default {
  name: "",
  components: {
    reginImageCheckedItem,
    reginImageCheckedDialogItem
  },
  data() {
    return {
      regionShow: [],
      allShow: false,
      fixDialog: false,
      region_img_info_list: [],
      activeImage: {}
    };
  },
  mounted() {
    // this.setSubTitle('模型检测');
    // this.getRegionImage();
  },
  methods: {
    ...mapMutations(["setSubTitle", 'emitLoading', 'removeLoading']),
    ...mapActions([]),
    changeShow() {
      this.allShow = !this.allShow;
    },
    cancelDialog() {
      this.fixDialog = false;
    },
    async confirmFixRegion({ id, fixedRegions }) {
      try {
        await apiFixRegions({
          id: this.activeImage.id,
          regions: fixedRegions,
          mark_user_name: this.username
        });
        this.$message.warning("修改成功");
      } catch (e) {
        console.log(e);
        this.$message.error("修改失败: " + e.message);
      }
      this.cancelDialog();
    },
    // async getRegionImage () {
    //   const res = await apiGetRegionImages();
    //   this.region_img_info_list = res.region_img_info_list;
    // },
    fixButtonClick(img, activeImage) {
      this.activeImage = {};
      this.fixDialog = true;
      this.activeImage = activeImage;
    }
  },
  computed: {
    ...mapGetters(["userinfo", "checkRegionData"]),
    count() {
      const imageList = this.imageList;
      imageList.forEach(a => {
        if (!a.hasOwnProperty('error_reason')) {
          this.$set(a, 'error_reason', 0);
        }
      });
      return this.$_.groupBy(this.imageList, "error_reason");
    },
    username() {
      return this.userinfo().username;
    },
    imageList() {
      let list = this.$_.cloneDeep(this.checkRegionData);
      // return list;
      // if (this.allShow) {
      //   return list;
      // } else {
      //   return list.filter(a => a.error_reason !== "0");
      // }
      // if (this.allShow) {
      //   return list;
      // } else {
      //   return list.filter(a => a.error_reason !== "0");
      // }
      return list;
    }
  },
  watch: {
    fixDialog(val, oldVal) {
      if (val === false) {
        this.activeImage = {};
      }
    },
    allShow () {
      this.regionShow = false;
      this.emitLoading(500);
      setTimeout(() => {
        this.regionShow = true;
      }, 500);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .region-img-item {
    display: inline-block;
    padding: 0 5px;
    vertical-align: top;
  }
  .box {
    border: 1px solid #ccc ;
    margin: 5px;
    padding: 5px;
    &>h3 {
      padding-left: 10px;
    }
  }
}
</style>
